import colors from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	unknown: {
		color: "#a5a5a5"
	},
	contact: {
		flex: 1,
		"&:hover": {
			textDecoration: "underline"
		},
		color: colors.palette.link,
		cursor: "pointer",
		fontSize: "20px"
	}
})

export default useStyles
